import type { FormStore, FormBuilderService } from '@cognitoforms/form-builder';

import { computed, shallowRef, shallowReadonly } from 'vue';

export const useBuilderAgent = () => {
	const builderService = shallowRef<FormBuilderService | undefined>();
	const formStore = shallowRef<FormStore | undefined>();

	const builderAgentEnabled = computed(() => !!builderService.value);

	const enableBuilderAgent = (newService: FormBuilderService, newStore: FormStore) => {
		builderService.value = newService;
		formStore.value = newStore;
	};

	const disableBuilderAgent = () => {
		builderService.value = formStore.value = undefined;
	};

	return { enableBuilderAgent, disableBuilderAgent, builderService: shallowReadonly(builderService), formStore: shallowReadonly(formStore), builderAgentEnabled };
};